import { useMemo, useState } from "react";
import { useSchoolFeedInfiniteScroll } from "./useSchoolFeedInfiniteScroll";
import moment from "moment-timezone";
import { currentRangeUrlQueryFormat, eventsQuery } from "../utils";
import { IFallbackData } from "../../../utils/SchoolBlocksUtilities";

export function useGetEvents(
  uniqueHookID: string,
  baseFilterParams?: { [k: string]: any } | null, // valid content item filtering parameters
  fallbackData?: IFallbackData,
) {
  const [currentRange, setCurrentRange] = useState({
    start: moment().startOf("month").format(currentRangeUrlQueryFormat),
    end: moment()
      .endOf("month")
      .add(1, "day")
      .format(currentRangeUrlQueryFormat), // add one day to include the last day of the month due to timezone weirdness
  });
  const gte = useMemo(() => {
    return moment(currentRange.start).format(currentRangeUrlQueryFormat);
  }, [JSON.stringify(currentRange)]);
  const lt = useMemo(() => {
    return moment(currentRange.end).format(currentRangeUrlQueryFormat);
  }, [JSON.stringify(currentRange)]);

  const {
    contentItems: events,
    error,
    isLoading,
    isValidating,
    mutate,
    size,
    setSize,
    totalContentItems,
    getItemAtIndex,
  } = useSchoolFeedInfiniteScroll(
    `${uniqueHookID}${JSON.stringify(currentRange)}`,
    eventsQuery(gte, lt, baseFilterParams),
    fallbackData,
  );

  return {
    events,
    error,
    isLoading,
    isValidating,
    mutate,
    size,
    setSize,
    totalContentItems,
    getItemAtIndex,
    currentRange,
    setCurrentRange,
  };
}
